import { assetUrl } from "~/utils/assetUrl"

type LogoSize = "large" | "small"

type LogoProps = {
  size: LogoSize
}

const imageSizeClasses: Record<LogoSize, string> = {
  large: "h-auto w-24",
  small: "h-auto w-14",
}

const textSizeClasses: Record<LogoSize, string> = {
  large: "text-2xl",
  small: "text-lg",
}

export function Logo({ size }: LogoProps) {
  return (
    <div
      className="flex items-center gap-2"
      role="img"
      aria-label="Doggy Dynamo"
    >
      <img
        src={assetUrl("/images/swish.png")}
        alt=""
        className={imageSizeClasses[size]}
        aria-hidden
      />
      <div className={`flex flex-col leading-tight font-semibold text-[var(--color-text-primary)] ${textSizeClasses[size]}`}>
        <span>Doggy</span>
        <span>Dynamo</span>
      </div>
    </div>
  )
}
